import './TemplateCard.css';

import { Card } from '@mui/material';
import React, { useEffect } from 'react';
import { fullImagePath } from '../../b2b-common/helpers';
import MoreButton from '../../b2b-common/MoreButton';
import { MoreVert, PostAdd } from '@mui/icons-material';
import EditPostModal from '../forms/EditPostModal';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const TemplateCard = ({ template, onSelect, onRefresh }) => {
    const { t } = useB2BTranslation('b2b-social');

    const [cardHovered, setCardHovered] = React.useState(false);

    const [currentTemplate, setCurrentTemplate] = React.useState(template);
    const [showNewPostModal, setShowNewPostModal] = React.useState(false);

    useEffect(() => {
        if ((!currentTemplate && template) ||
            (currentTemplate && template && currentTemplate.socialPostTemplateId !== template.socialPostTemplateId)) {
            setCurrentTemplate(template);
        }
    }, [template]);

    const getScopeText = (scope) => {
        switch (scope) {
            case 'ORGANIZATION':
                return t('Organization');
            case 'PLAN':
                return t('Plan');
            case 'AREA':
                return t('Area');
            case 'AREA_INDICATOR':
                return t('Area Indicator');
            default:
                return t('Unknown');
        }
    }

    const handleClickOnCard = () => {
        onSelect && onSelect(currentTemplate);
     }

    const handleSavedPost = () => {
        setShowNewPostModal(false);
        onRefresh();
     }

    return (
        <Card variant='outlined'
            onMouseEnter={() => setCardHovered(true)}
            onMouseLeave={() => setCardHovered(false)}
            className={`template-card ${cardHovered ? 'template-card-hovered' : ''} `}
            onClick={handleClickOnCard}
        >
            {cardHovered && (
                <MoreButton icon={<MoreVert />}
                    buttons={[
                        {
                            label: t('New post'),
                            icon: <PostAdd />,
                            rolesAllowed: ['ADMIN', 'EDITOR'],
                            onClick: () => setShowNewPostModal(true),
                        },
                    ]}
                    dropPositionAlign='right'
                    rolesAllowed={['ADMIN', 'EDITOR']}
                    className={'jb01-more-button'}
                />
            )}
            <div className='template-card-header'>
                <img src={fullImagePath(currentTemplate.templateImage)} alt='' className='template-card-image' />
            </div>
            <div className='template-card-content'>
                <div className='template-card-scope'>
                    {getScopeText(currentTemplate.socialPostScope)}
                </div>
                <div className='template-card-title'>{currentTemplate.socialPostTemplateName}</div>
                <div className='template-card-description'>{currentTemplate.socialPostTemplateDescription}</div>
            </div>
            <EditPostModal
                operation='CREATE'
                post={null}
                template={currentTemplate} 
                open={showNewPostModal}
                onClose={() => setShowNewPostModal(false)}
                onSavedPost={(post) => handleSavedPost(post)}
            />
        </Card>
    )
}

export default TemplateCard;